import { inject, Injectable } from "@angular/core"
import { OkxWebsocketClient } from "../../../market"
import { filter, first, Observable } from "rxjs"
import { Position, PositionSide } from "../../../model/trade"
import { isWsDataPositionEvent, WsDataEvent } from "libs/okx-api/src"
import { parseFloatSafe, parseIntSafe } from "src/app/core/func"
import { BoardId } from "src/app/core/model/common"
import { InstrumentStorageService } from "../../instrument-storage.service"

@Injectable({
  providedIn: 'root'
})
export class OkxPositionHandler {

  private instrumentStorage = inject(InstrumentStorageService)

  listen(ws: OkxWebsocketClient) {
    return new Observable<Position>(subscriber => {
      const f = (data: WsDataEvent) => {
        if (isWsDataPositionEvent(data)) {
          data.data.forEach(row => {
            this.instrumentStorage.listen('okx', 'swap', row.instId).pipe(
              filter(instrument => instrument != undefined),
              first(),
            ).subscribe(instrument => {
              const position: Position = {
                createdTimestamp: parseIntSafe(row.uTime),
                updateTimestamp: parseIntSafe(row.uTime),
                market: 'okx',
                board: row.instType.toLowerCase() as BoardId,
                symbol: row.instId,
                entryPrice: row.avgPx,
                liquidationPrice: row.liqPx,
                size: row.pos,
                positionSide: row.posSide === 'long' ? PositionSide.long : row.posSide === 'short' ? PositionSide.short : PositionSide.both,
                positionVolume: parseFloatSafe(row.pos) * parseFloatSafe(row.avgPx) * instrument.lotSize,
                unrealisedPnl: row.upl,
              }
              subscriber.next(position)
            })
          })
        }
      }

      ws.on('update', f)
      return () => ws.off('update', f)
    })
  }

}
